import React from "react";
import { Quote, Star, Phone, Star as StarIcon, ExternalLink } from "lucide-react";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";
import { TESTIMONIALS, CONTACT } from "../mock";

const GOOGLE_REVIEW_URL = "https://g.page/r/CTPVB8lPZngLEBM/review";

const Testimonials = () => {
  return (
    <div>
      <Seo
        title="Client Testimonials | Roger Minner Real Estate, Kennett Square PA"
        description="Read reviews from home buyers and sellers who worked with Roger Minner in Kennett Square, West Chester, PA and Chester County, and see why clients trust him with their move."
      />
      <PageBanner
        eyebrow="In Their Words"
        title="Testimonials"
        subtitle="Hear from the families we've had the privilege to serve."
        image="https://images.unsplash.com/photo-1594348352384-97fa22a08109?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80"
      />

      <section className="bg-[#f6f2ed] py-20 md:py-24">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8">
            {TESTIMONIALS.map((t) => (
              <Reveal key={t.id}>
                <div className="bg-white rounded-sm p-8 md:p-10 h-full shadow-[0_18px_45px_-30px_rgba(58,55,54,0.4)] relative">
                  <Quote size={44} className="text-[#e3d6d8] absolute top-6 right-7" fill="currentColor" />
                  <div className="flex gap-1 mb-5">
                    {["one", "two", "three", "four", "five"].map((n) => (
                      <Star key={`${t.id}-${n}`} size={18} className="text-[#b6a4a7]" fill="currentColor" />
                    ))}
                  </div>
                  <p className="font-serif-el text-xl md:text-2xl leading-relaxed text-[#3a3736] italic">
                    “{t.quote}”
                  </p>
                  <div className="mt-7 pt-6 border-t border-[#eae2d9]">
                    <p className="brand-title text-2xl text-[#3a3736] uppercase">{t.name}</p>
                    <p className="font-sans-el text-sm tracking-[0.15em] uppercase text-[#9a878b] mt-1">{t.location}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="text-center mt-16">
            <p className="font-serif-el text-2xl text-[#3a3736] mb-6">
              Ready to write your own success story?
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={GOOGLE_REVIEW_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-mauve inline-flex items-center gap-2 px-8 py-4 rounded-sm"
              >
                <StarIcon size={16} /> Review Us on Google <ExternalLink size={15} />
              </a>
              <a
                href={`tel:${CONTACT.phoneRaw}`}
                className="inline-flex items-center gap-2 border border-[#6f5f62] text-[#6f5f62] px-8 py-4 rounded-sm font-sans-el tracking-[0.14em] uppercase text-sm hover:bg-[#6f5f62] hover:text-white transition-all duration-300"
              >
                <Phone size={16} /> Call Roger: {CONTACT.phone}
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
